import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ArrowRight, AlertTriangle, CheckCircle, Zap } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SEO from '../components/SEO';
import { parseMarkdownItalics } from '../components/SafecareBrand';
// static import removed
import '../components/layout/PageHero.css';
import '../components/layout/PageHero.css';
import './ShockTherapy.css';
const SeriesSection = ({ series }) => {
    return (
        <section className="shock-series-section">
            <div className="shock-series-header">
                <h2>{parseMarkdownItalics(series.title)}</h2>
                <p>{parseMarkdownItalics(series.theme)}</p>
            </div>
            <div className="shock-articles-grid">
                {series.articles.map((article) => (
                    <Link to={`/shock-therapy/${article.id}`} key={article.id} className="shock-card">
                        <div className="shock-card-image">
                            <img src={article.image} alt={article.title} loading="lazy" />
                            <div className="shock-card-overlay" />
                        </div>
                        <div className="shock-card-content">
                            <h3>{parseMarkdownItalics(article.title)}</h3>
                            <p>{parseMarkdownItalics(article.summary)}</p>
                            <span className="shock-read-btn">
                                Open File <ArrowRight size={16} />
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};

// Table of Contents Component
const TableOfContents = ({ shockData }) => {
    return (
        <div className="shock-toc-container">
            <h3 className="shock-toc-header">Mission Control</h3>
            <div className="shock-toc-grid">
                {shockData?.series?.map((series, index) => (
                    <a href={`#${series.id}`} key={series.id} className="shock-toc-card">
                        <div className="shock-toc-number">{(index + 1).toString().padStart(2, '0')}</div>
                        <div className="shock-toc-info">
                            <span className="shock-toc-title">{parseMarkdownItalics(series.title)}</span>
                            <span className="shock-toc-subtitle">{parseMarkdownItalics(series.subtitle)}</span>
                        </div>
                        <ArrowRight className="shock-toc-arrow" size={16} />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default function ShockTherapyLanding() {
    const { hash } = useLocation();
    const [shockData, setShockData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/data/shock_therapy_index.json')
            .then(res => res.json())
            .then(data => {
                setShockData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to load shock therapy data", err);
                setLoading(false);
            });
    }, []);

    // Handle hash scrolling on load/navigation
    useEffect(() => {
        if (hash) {
            const id = hash.replace('#', '');
            // Small timeout to ensure DOM is ready and layout is stable
            const timer = setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 300); // 300ms is usually safe for React rendering
            return () => clearTimeout(timer);
        }
    }, [hash]);

    return (
        <div className="shock-page">
            <SEO
                title="Shock Therapy - SAFEC+"
                description="Demystifying the scams of the current healthcare system and explaining exactly how SAFECARE fixes them."
                image="/image/shock_cover.png"
            />

            <Header />

            {/* Hero Banner aligned with other pages */}
            <div className="page-hero" style={{ marginBottom: '4rem' }}>
                <div className="page-hero-bg-wrapper">
                    <img className="page-hero-img" alt="Shock Therapy" src="/image/shock_cover.png" />
                    <div className="page-hero-overlay"></div>
                </div>
                <div className="container page-hero-content">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1 style={{
                            fontSize: 'clamp(3rem, 5vw, 5rem)',
                            fontWeight: '800',
                            marginBottom: '1rem',
                            letterSpacing: '-0.02em',
                            color: '#fff',
                            textShadow: '0 4px 20px rgba(0,0,0,0.5)'
                        }}>
                            SHOCK THERAPY
                        </h1>
                        <p style={{ fontSize: '1.5rem', color: '#e2e8f0', maxWidth: '600px', margin: '0 auto', textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
                            The system isn't broken. It was built this way. <br />
                            <span style={{ color: 'rgba(255,255,255,0.95)', fontWeight: '700', textDecoration: 'underline', textUnderlineOffset: '4px' }}>Here is the blueprint of the theft.</span>
                        </p>
                    </motion.div>
                </div>
            </div>

            <div className="shock-hub-container">

                {loading && <div style={{ textAlign: 'center', padding: '2rem', color: '#fff' }}>Loading Content...</div>}

                {shockData && (
                    <>
                        <TableOfContents shockData={shockData} />

                        <div className="shock-content-separator" />

                        {shockData.series.map((series) => (
                            <div id={series.id} key={series.id} style={{ scrollMarginTop: '100px' }}>
                                <SeriesSection series={series} />
                            </div>
                        ))}
                    </>
                )}
            </div>

            <Footer />
        </div >
    );
}


